/** Slider scales — RULES-ENGINE.md "log500k". */

export type Segment = [from: number, to: number, step: number];

export const LOG500K: Segment[] = [
  [0, 1000, 100],
  [1000, 10000, 500],
  [10000, 100000, 1000],
  [100000, 500000, 10000],
];

export const SCALES: Record<string, Segment[]> = {
  log500k: LOG500K,
  linear: [[0, 500000, 1000]],
};

/** Thumb position r ∈ [0,1] → value. */
export function toValue(r: number, segments: Segment[] = LOG500K): number {
  if (r >= 1) return segments[segments.length - 1][1];
  const clamped = Math.max(0, r);
  const n = segments.length;
  const i = Math.min(n - 1, Math.floor(clamped * n));
  const t = clamped * n - i;
  const [from, to, step] = segments[i];
  return Math.round((from + (to - from) * t) / step) * step;
}

/** value → thumb position r ∈ [0,1]; inverse of toValue (to within one step). */
export function toRatio(value: number, segments: Segment[] = LOG500K): number {
  const n = segments.length;
  const max = segments[n - 1][1];
  if (value >= max) return 1;
  if (value <= segments[0][0]) return 0;
  const i = segments.findIndex(([from, to]) => value >= from && value < to);
  const idx = i === -1 ? n - 1 : i;
  const [from, to] = segments[idx];
  const t = (value - from) / (to - from);
  return (idx + t) / n;
}

/** `num` filter: 500K+ / 1.2K / 850 */
export function formatNum(n: number): string {
  if (!Number.isFinite(n)) return '';
  if (n >= 500000) return '500K+';
  if (n >= 1000) {
    const k = n / 1000;
    return `${k.toFixed(k % 1 === 0 ? 0 : 1).replace(/\.0$/, '')}K`;
  }
  return String(Math.round(n));
}

export const AGREE_STOPS = [0, 0.25, 0.5, 0.75, 1] as const;
export const DEFAULT_AGREE_LABELS = ['Not me', 'Rarely', 'Sometimes', 'Often', 'Very me'];

/** Agree slider snaps to the nearest quarter on release. */
export const snapAgree = (r: number): number => Math.round(Math.max(0, Math.min(1, r)) * 4) / 4;
